<template>
  <div class="p-1 text-left bg-light fw-bold rounded border border-white">
    <div class="d-flex justify-content-between">
      <div class="mt-0">
        <span class="text-sm" ref="modeText">{{veh.mode}}</span><br>
        <div ref="editPanel" style="display: none;">
          <input type="text" style="width:120px" :placeholder="veh.mode" v-model="modeInput">
          <button class="btn-success submit-btn" @click="this.submitChange()"><i class="fas fa-check"></i></button>
        </div>
      </div>
      <div class="text-xl">
        <button type="button" class="submit-btn" @click="this.checkIsMobile()">
          <i role="button" class="fa-solid fa-pen-to-square"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Popper from 'vue3-popper'
export default {
  name: 'ModeCell',
  components: { Popper },
  props: ['veh'],
  data(){
    return {
      modeInput:''
    }
  },
  methods:{
    showEditPanel(){
      this.$refs.editPanel.classList.toggle('show')
    },
    submitChange(){
      if(this.modeInput == ''){
        Swal.fire('Uzupełnij pole trybu', '', 'error')
      }else{
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        const putData = {
          mode: this.modeInput
        }
        axios.put(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.veh.id}`, putData, config)
          .then(re => {
            // console.log(re);
            if(String(re.status).charAt(0) == '2'){
              this.veh.mode = this.modeInput
              Swal.fire('pomyślnie zmieniono tryb', '', 'success')
            }else{
              Swal.fire('Coś poszło nie tak', '', 'error')

            }
          })
          .catch(err => {
            console.log(er);
          })
      }
    },
    checkIsMobile(){
      if(window.screen.width < 450){
        this.modeInput = prompt('podaj tryb')
        this.submitChange()
      }else{
        this.showEditPanel()
      }
    }
  }
}
</script>

<style scoped>
.show{
  display: block !important;
}
.submit-btn{
  border: none;
  border-radius: 3px;
}
</style>
